module.exports = function (a) {
    var guid = $(this).data('guid');
    require('./add_to_cart.js')(guid);
};